<template>
  <v-container fluid>
    <PageHeading
      :text="'Организаторы мероприятий'"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-event-organizer-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Создать организатора мероприятий
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridPageEventOrganizers ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridPageEventOrganizers from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageEventOrganizers',
  components: {
    PageHeading,
    GridPageEventOrganizers
  },
  metaInfo () {
    return {
      title: 'Организаторы мероприятий'
    }
  },
  mixins: [gridPageInterface]
}
</script>
